import { __rest } from "tslib";
import React from 'react';
import { staggerChildrenAnimation, fallingAnimation } from './animations';
export var AnimationType;
(function (AnimationType) {
    AnimationType[AnimationType["staggerChildren"] = 0] = "staggerChildren";
    AnimationType[AnimationType["falling"] = 1] = "falling";
})(AnimationType || (AnimationType = {}));
const variantsMap = {
    [AnimationType.staggerChildren]: staggerChildrenAnimation,
    [AnimationType.falling]: fallingAnimation,
};
const Animated = (_a) => {
    var { Component, animation } = _a, restProps = __rest(_a, ["Component", "animation"]);
    const variants = variantsMap[animation];
    return React.createElement(Component, Object.assign({ variants: variants }, restProps));
};
export default Animated;
//# sourceMappingURL=Animated.js.map